import { func, string } from 'prop-types';

import Button from 'shared/components/button/Button';
import Checkmark from 'shared/components/icon/Checkmark';
import Close from 'shared/components/icon/Close';
import { getText } from 'shared/utils/Text';

const ConfirmDelete = ({ confirmHandler, cancelHandler, label }) => (
  <div className="confirm-delete-wrapper fgrid fgrid--center">
    <span className="fgrid-cell title">{label}</span>
    <Button className="button confirm-trash" onClick={confirmHandler}>
      <span className="button__inner">
        <span className="button__icon">
          <Checkmark />
        </span>
        <span className="button__text">
          {getText('dialog-confirm-confirm')}
        </span>
      </span>
    </Button>
    <Button className="button confirm-cancel" onClick={cancelHandler}>
      <span className="button__inner">
        <span className="button__icon">
          <Close />
        </span>
        <span className="button__text">{getText('dialog-confirm-cancel')}</span>
      </span>
    </Button>
  </div>
);

ConfirmDelete.propTypes = {
  confirmHandler: func.isRequired,
  cancelHandler: func.isRequired,
  label: string.isRequired,
};

export default ConfirmDelete;
